// import React from 'react'

// import {UserProvider } from './UserContext'
// import {ArticleProvider } from './ArticleContext'
// import {CarProvider } from './CarContext'

// const providers = [
//     UserProvider,
//     ArticleProvider,
//     CarProvider
// ]

// const ContextProvider = (...components: React.FC[]): React.FC => (
//     components.reduce(
//         (AccumComponents,Component) => (
//             ({children}): JSX.Element => (
//                 <AccumComponents>
//                     <Component>{children}</Component>
//                 </AccumComponents>
//             )
//         ),
//         ({children}) => <>{children}</>
//     )
// )

// export default ContextProvider(...providers)
import React, { ReactNode } from "react";

import { UserProvider } from "./UserContext";
import { ArticleProvider } from "./ArticleContext";
import { CarProvider } from "./CarContext";

interface Props {
  children: ReactNode;
}

const ContextProvider = ({ children }: Props): JSX.Element => {
  return (
    <UserProvider>
      <ArticleProvider>
        <CarProvider>
          {children}
        </CarProvider>
      </ArticleProvider>
    </UserProvider>
  );
};

export default ContextProvider;
